export default {
  LOCALIZATION: "localization",
  FLAG_ECOM_489: "flag_ecom_489",
};
